<script lang="ts" setup>
import type { FindOrderOut } from '~/types/ecommerce/generated.codegen';
import { CustomerOrder } from '~/types/orders';

const props = defineProps<{
  order: FindOrderOut;
}>();

const invoice = computed(() => props.order.invoice_info);
const personType = computed(() => invoice.value?.customer_type === CustomerOrder.NATURAL_PERSON ? 'Pessoa Física' : 'Pessoa Jurídica');
const documentType = computed(() => invoice.value?.customer_type === CustomerOrder.NATURAL_PERSON ? 'CPF' : 'CNPJ');
const observation = ref(props.order.notes.invoice || '');
</script>

<template>
  <div class="invoice-data-content">
    <div class="header">
      <span class="title">Dados da Nota Fiscal</span>
    </div>
    <div class="info-content">
      <div class="info-base">
        <div class="info-item">
          <span class="label">Tipo do cliente</span>
          <span class="value">{{ personType }}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ documentType }}</span>
          <span class="value">{{ invoice.customer_document }}</span>
        </div>
        <div class="info-item">
          <span class="label">E-mail</span>
          <span class="value">{{ invoice.customer_email }}</span>
        </div>
        <div class="info-item">
          <span class="label">Celular</span>
          <span class="value">{{ invoice.customer_phone }}</span>
        </div>
        <div class="info-item" v-if="invoice.customer_state_registration">
          <span class="label">Inscrição Estadual</span>
          <span class="value">{{ invoice.customer_state_registration }}</span>
        </div>
      </div>
      <div class="address-content">
        <span class="title">Endereço de faturamento</span>
        <span class="address">{{ invoice.invoice_address }}</span>
      </div>
      <SolDivider orientation="horizontal" thickness="x-small" />
      <div class="obs-container">
        <span class="obs-title">Observações (opcional)</span>
        <SolInputTextarea
          id="obs"
          v-model="observation"
          name="obs"
          disabled
          placeholder="Seu texto aqui"
          class="obs-input"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.invoice-data-content {
  @apply flex flex-col gap-4xs px-4xs py-2xs;
  @apply border-1 border-neutral-high-medium rounded-lg;

  .header {
    @apply block;

    .title {
      @apply fonts-heading-h3;
    }
  }

  .info-content {
    @apply flex flex-col gap-4xs;

    .info-base {
      @apply flex flex-col gap-micro;

      .info-item {
        @apply flex flex-col;

        .label {
          @apply fonts-body-small-regular text-neutral-low-light;
        }

        .value {
          @apply fonts-body-medium-regular text-neutral-low-pure;
        }
      }
    }

    .address-content {
      @apply flex flex-col gap-micro;

      .title {
        @apply fonts-body-large-bold text-brand-primary-dark;
      }

      .address {
        @apply fonts-body-medium-regular text-neutral-low-dark;
      }
    }

    .obs-container {
      @apply flex flex-col gap-quark;

      .obs-title {
        @apply fonts-body-medium-bold text-neutral-high-dark;
      }
    }
  }
}
</style>
